(function() {
  'use strict';

  var BUNDLE_HANDLES = [
    'el-tridente-attackers-bundle-plus',
    'el-motor-midfielders-bundle-plus',
    'la-muralla-defenders-bundle-plus'
  ];

  var DEFAULT_HANDLE = BUNDLE_HANDLES[0];

  // --- State ---
  var selectedHandles = [DEFAULT_HANDLE];
  var lastSelectedHandle = DEFAULT_HANDLE;

  // --- DOM queries ---
  function getAllBundleCards() {
    return document.querySelectorAll('[data-bundle-handle]');
  }

  // --- Sticky data ---
  var stickyData = null;

  function getStickyData() {
    if (stickyData) return stickyData;
    var el = document.querySelector('[data-bundles-sticky-data]');
    if (el) {
      try { stickyData = JSON.parse(el.textContent); } catch(e) { stickyData = {}; }
    }
    return stickyData || {};
  }

  // --- Money formatting ---
  var moneyFormat = null;

  function getMoneyFormat() {
    if (moneyFormat) return moneyFormat;
    var el = document.querySelector('[data-bundles-money-format]');
    if (el) {
      try { moneyFormat = JSON.parse(el.textContent); } catch(e) { moneyFormat = '{{amount}}'; }
    }
    return moneyFormat || '{{amount}}';
  }

  function formatMoney(cents) {
    var fmt = getMoneyFormat();
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100).toString();
    var amountWithComma = amount.replace('.', ',');

    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  // --- Gift variant IDs ---
  function getGiftVariantIds() {
    var el = document.querySelector('[data-gift-variant-ids]');
    if (!el) return [];
    try { return JSON.parse(el.textContent).filter(Boolean); } catch(e) { return []; }
  }

  // --- Price calculations ---
  function getSelectedTotals() {
    var data = getStickyData();
    var totalPrice = 0;
    var totalCompare = 0;
    var allAvailable = true;

    selectedHandles.forEach(function(h) {
      var d = data[h];
      if (!d) return;
      totalPrice += d.priceRaw;
      totalCompare += d.compareAtPriceRaw || 0;
      if (!d.available) allAvailable = false;
    });

    return {
      totalPrice: totalPrice,
      totalCompare: totalCompare,
      allAvailable: allAvailable,
      count: selectedHandles.length
    };
  }

  // --- Bundle toggling (multi-select) ---
  function toggleBundle(handle) {
    if (BUNDLE_HANDLES.indexOf(handle) === -1) return;

    var idx = selectedHandles.indexOf(handle);

    if (idx !== -1) {
      // Already selected: try to deselect
      if (selectedHandles.length <= 1) {
        shakeBundleCard(handle);
        return;
      }
      selectedHandles.splice(idx, 1);
      if (lastSelectedHandle === handle) {
        lastSelectedHandle = selectedHandles[selectedHandles.length - 1];
      }
    } else {
      // Not selected: add it
      selectedHandles.push(handle);
      lastSelectedHandle = handle;
    }

    updateUI();
  }

  function shakeBundleCard(handle) {
    var card = document.querySelector('[data-bundle-handle="' + handle + '"]');
    if (!card) return;
    card.classList.add('bundle-card--shake');
    card.addEventListener('animationend', function() {
      card.classList.remove('bundle-card--shake');
    }, { once: true });
  }

  // --- UI updates ---
  function updateUI() {
    // Update bundle card visual states
    getAllBundleCards().forEach(function(card) {
      var h = card.dataset.bundleHandle;
      var isSelected = selectedHandles.indexOf(h) !== -1;
      card.classList.toggle('bundle-card--selected', isSelected);
      card.setAttribute('aria-pressed', isSelected);
    });

    // Show/hide media panels: only lastSelectedHandle's gallery visible
    BUNDLE_HANDLES.forEach(function(h) {
      var panels = document.querySelectorAll('.bundles-product__media-panel[data-bundle-panel="' + h + '"]');
      panels.forEach(function(p) { p.hidden = (h !== lastSelectedHandle); });
    });

    // Show/hide detail panels (ratings, title, etc.)
    BUNDLE_HANDLES.forEach(function(h) {
      var panels = document.querySelectorAll('.bundles-product__details-panel[data-bundle-panel="' + h + '"]');
      panels.forEach(function(p) { p.hidden = (h !== lastSelectedHandle); });
    });

    updatePriceSummary();
    updateStickyButton();

    // Update URL
    var url = new URL(window.location);
    if (selectedHandles.length === 1) {
      url.searchParams.set('bundle', selectedHandles[0]);
      url.searchParams.delete('bundles');
    } else {
      url.searchParams.set('bundles', selectedHandles.join(','));
      url.searchParams.delete('bundle');
    }
    history.replaceState(null, '', url);
  }

  function updatePriceSummary() {
    var totals = getSelectedTotals();

    var compareEl = document.querySelector('[data-summary-compare-price]');
    var currentEl = document.querySelector('[data-summary-current-price]');
    var countEl = document.querySelector('[data-summary-count]');

    if (currentEl) currentEl.textContent = formatMoney(totals.totalPrice);
    if (compareEl) {
      if (totals.totalCompare > totals.totalPrice) {
        compareEl.textContent = formatMoney(totals.totalCompare);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (countEl) {
      countEl.textContent = totals.count > 1 ? '(' + totals.count + ' bundles)' : '';
    }
  }

  function updateStickyButton() {
    var totals = getSelectedTotals();
    var btn = document.querySelector('[data-bundles-sticky-atc]');
    if (!btn) return;

    var actionEl = btn.querySelector('[data-sticky-action]');
    var titleEl = btn.querySelector('[data-sticky-title]');
    var priceEl = btn.querySelector('[data-sticky-price]');
    var comparePriceEl = btn.querySelector('[data-sticky-compare-price]');

    if (actionEl) actionEl.textContent = totals.allAvailable ? 'Proceed to Checkout' : 'Sold Out';

    if (totals.count === 1) {
      var singleData = getStickyData()[selectedHandles[0]];
      if (singleData) {
        if (titleEl) titleEl.textContent = singleData.title;
        if (priceEl) priceEl.textContent = singleData.price;
        if (comparePriceEl) {
          comparePriceEl.textContent = singleData.compareAtPrice;
          comparePriceEl.style.display = singleData.hasComparePrice ? '' : 'none';
        }
      }
    } else {
      if (titleEl) titleEl.textContent = totals.count + ' Bundles Selected';
      if (priceEl) priceEl.textContent = formatMoney(totals.totalPrice);
      if (comparePriceEl) {
        if (totals.totalCompare > totals.totalPrice) {
          comparePriceEl.textContent = formatMoney(totals.totalCompare);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
    }

    btn.disabled = !totals.allAvailable;
  }

  // --- Sticky add-to-cart button ---
  function initStickyAddToCart() {
    var stickyBtn = document.querySelector('[data-bundles-sticky-atc]');
    var sentinel = document.querySelector('.bundles-atc-sentinel');
    if (!stickyBtn) return;

    // Click handler: submit the shared form
    stickyBtn.addEventListener('click', function() {
      var form = document.querySelector('[data-bundles-atc-form]');
      if (form) {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });

    // Mobile sticky visibility via IntersectionObserver
    if (window.innerWidth <= 749 && sentinel) {
      var observer = new IntersectionObserver(function(entries) {
        var entry = entries[0];
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          stickyBtn.style.display = 'inline-flex';
        } else {
          stickyBtn.style.display = 'none';
        }
      }, {
        threshold: 0,
        rootMargin: '0px'
      });

      observer.observe(sentinel);
    }
  }

  // --- Media gallery ---
  function initGalleries() {
    var panels = document.querySelectorAll('.bundles-product__media-panel');

    panels.forEach(function(panel) {
      var grid = panel.querySelector('.media-gallery__grid');
      if (!grid) return;

      var thumbnails = panel.querySelectorAll('.media-gallery__thumbnail');
      var mediaContainers = panel.querySelectorAll('.media-gallery__grid .product-media-container');
      var totalSlides = mediaContainers.length;
      var currentIndex = 0;

      function goToSlide(index, direction) {
        if (index < 0 || index >= totalSlides || index === currentIndex) return;

        var currentSlide = grid.querySelector('[data-media-index="' + currentIndex + '"]');
        var nextSlide = grid.querySelector('[data-media-index="' + index + '"]');
        if (!currentSlide || !nextSlide) return;

        if (direction === 'left') {
          currentSlide.classList.add('slide-out-left');
        } else if (direction === 'right') {
          currentSlide.classList.add('slide-out-right');
        }
        currentSlide.classList.remove('active');

        if (direction === 'left') {
          nextSlide.classList.add('slide-in-left');
        } else if (direction === 'right') {
          nextSlide.classList.add('slide-in-right');
        }
        nextSlide.classList.add('active');

        thumbnails.forEach(function(t) { t.classList.remove('active'); });
        var activeThumbnail = panel.querySelector('[data-thumbnail-index="' + index + '"]');
        if (activeThumbnail) {
          activeThumbnail.classList.add('active');
          activeThumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }

        currentIndex = index;

        function cleanup() {
          mediaContainers.forEach(function(m) {
            m.classList.remove('slide-out-left', 'slide-out-right', 'slide-in-left', 'slide-in-right');
          });
        }

        currentSlide.addEventListener('transitionend', cleanup, { once: true });
        setTimeout(cleanup, 400);
      }

      thumbnails.forEach(function(thumbnail) {
        thumbnail.addEventListener('click', function() {
          var index = parseInt(this.getAttribute('data-thumbnail-index'), 10);
          var direction = index > currentIndex ? 'left' : 'right';
          goToSlide(index, direction);
        });
      });

      // Touch/swipe handlers
      var touchStartX = 0;
      var touchStartY = 0;
      var touchMoveX = 0;
      var touchMoveY = 0;

      grid.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchMoveX = touchStartX;
        touchMoveY = touchStartY;
      }, { passive: true });

      grid.addEventListener('touchmove', function(e) {
        touchMoveX = e.touches[0].clientX;
        touchMoveY = e.touches[0].clientY;
        var dx = Math.abs(touchMoveX - touchStartX);
        var dy = Math.abs(touchMoveY - touchStartY);

        if (dx > dy && dx > 10) {
          e.preventDefault();
        }
      }, { passive: false });

      grid.addEventListener('touchend', function() {
        var dx = touchMoveX - touchStartX;
        var dy = touchMoveY - touchStartY;
        var absDx = Math.abs(dx);
        var absDy = Math.abs(dy);

        if (absDx > 50 && absDx > absDy) {
          if (dx < 0) {
            goToSlide(currentIndex + 1, 'left');
          } else {
            goToSlide(currentIndex - 1, 'right');
          }
        }
      }, { passive: true });
    });
  }

  // --- AJAX add to cart (multi-select) ---
  function initAddToCartForms() {
    document.querySelectorAll('[data-bundles-atc-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var button = form.querySelector('.add-to-cart-button');
        if (!button || button.disabled) return;

        var data = getStickyData();
        var giftIds = getGiftVariantIds();

        button.disabled = true;
        button.innerHTML = 'Processing...';

        // Build items: all selected bundles + gifts
        var items = [];
        selectedHandles.forEach(function(h) {
          var d = data[h];
          if (d && d.variantId) {
            items.push({ id: d.variantId, quantity: 1 });
          }
        });
        var bundleCount = selectedHandles.length;
        giftIds.forEach(function(id) {
          items.push({ id: parseInt(id), quantity: bundleCount });
        });

        // Clear cart, add all items, redirect to checkout with discount
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (data.status) {
            throw new Error(data.description || 'Could not add to cart');
          }
          window.location.href = '/discount/FIRSTORDERDISCOUNT_SPRING26?redirect=/checkout';
        })
        .catch(function(error) {
          alert(error.message);
          button.disabled = false;
          button.innerHTML = button.dataset.originalText || 'Proceed to Checkout';
        });
      });
    });
  }

  // --- Header cart icon visibility ---
  function updateHeaderCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartLink = document.querySelector('[data-bundles-cart-link]');
        var cartCount = document.querySelector('[data-bundles-cart-count]');
        if (cartLink) {
          cartLink.classList.toggle('bundles-header__cart--empty', cart.item_count === 0);
        }
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
      })
      .catch(function() { /* silently fail */ });
  }

  // --- Init ---
  function init() {
    var params = new URLSearchParams(window.location.search);

    // Support multi-select URL param
    var bundlesParam = params.get('bundles');
    var bundleParam = params.get('bundle');

    if (bundlesParam) {
      var handles = bundlesParam.split(',').filter(function(h) {
        return BUNDLE_HANDLES.indexOf(h) !== -1;
      });
      if (handles.length > 0) {
        selectedHandles = handles;
        lastSelectedHandle = handles[handles.length - 1];
      }
    } else if (bundleParam && BUNDLE_HANDLES.indexOf(bundleParam) !== -1) {
      selectedHandles = [bundleParam];
      lastSelectedHandle = bundleParam;
    }

    // Apply initial state to DOM
    getAllBundleCards().forEach(function(card) {
      var h = card.dataset.bundleHandle;
      var isSelected = selectedHandles.indexOf(h) !== -1;
      card.classList.toggle('bundle-card--selected', isSelected);
      card.setAttribute('aria-pressed', isSelected);
    });

    // Show/hide panels for initial state
    BUNDLE_HANDLES.forEach(function(h) {
      var panels = document.querySelectorAll('[data-bundle-panel="' + h + '"]');
      panels.forEach(function(p) { p.hidden = (h !== lastSelectedHandle); });
    });

    // Initial price update
    updatePriceSummary();
    updateStickyButton();

    // Card click handlers — toggle instead of switch
    getAllBundleCards().forEach(function(card) {
      card.addEventListener('click', function() {
        toggleBundle(this.dataset.bundleHandle);
      });
    });

    initGalleries();
    initAddToCartForms();
    initStickyAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
